import { Component, effect, ElementRef, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IndexHeaderinfoComponent } from '../../components/index/index-headerinfo/index-headerinfo.component';
import { IndexKeyinfoComponent } from '../../components/index/index-keyinfo/index-keyinfo.component';
import { IndexPerfriskinfoComponent } from '../../components/index/index-perfriskinfo/index-perfriskinfo.component';
import {
  IndexPerformanceChartComponent
} from '../../components/index/index-performancechart/index-performance-chart.component';
import { IndexFooterComponent } from '../../components/index/index-footer/index-footer.component';
import { IndexIoService } from '../../services/index-io.service';
import { ProgressSpinner } from 'primeng/progressspinner';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'bnpp-indx-index',
  imports: [
    IndexHeaderinfoComponent,
    IndexKeyinfoComponent,
    IndexPerfriskinfoComponent,
    IndexPerformanceChartComponent,
    IndexFooterComponent,
    ProgressSpinner,
    CommonModule
  ],
  templateUrl: './index.component.html',
  styleUrl: './index.component.scss',
  standalone: true,
})
export class IndexComponent implements OnInit {
  private indexInfoService = inject(IndexIoService);
  mdsCodeValue = signal<string>('');
  startDateValue: string = '';
  endDateValue: string = '';
  productId = signal<string>('');
  subProductId = signal<string>('');


  constructor(private route: ActivatedRoute, private elementRef: ElementRef) {
    effect(() => {
      const mdsCode = this.mdsCodeValue();
      const productId = this.productId();
      const subId = this.subProductId();
      if (!mdsCode && productId && subId) {
        this.indexInfoService.getProductDetailsFromSubProductId(subId).subscribe({
          next: (details) => {
            this.mdsCodeValue.set(details.CodeMDS);
          }
        })
      }
    })
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.mdsCodeValue.set(params['mdsCode']); // Replace 'paramName' with your actual parameter name
      this.productId.set(params['pid']);
      this.subProductId.set(params['subid']);
      this.startDateValue = params['startDate']; // Replace 'paramName' with your actual parameter name
      this.endDateValue = params['endDate']; // Replace 'paramName' with your actual parameter name
    });
  }

}
